import { render, staticRenderFns } from "./SectionItemTag.vue?vue&type=template&id=37688eb9&lang=pug&"
import script from "./SectionItemTag.vue?vue&type=script&lang=js&"
export * from "./SectionItemTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports